import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";
import "./Wallet.css";
import CircularProgressWithLabel from "../CircularProgressWithLabel";
import WalletBalance from "../layout/WalletBalance";

const Budget = ({ budget, onBudgetClick }) => {
    const balances = budget.balances ?? [];
    const mainBalance =
        balances.find((b) => b.currency === budget.currency) ??
        { currency: budget.currency, value: 0 };
    const otherBalances = balances.filter((b) => b.currency !== budget.currency);

    const balanceValue = Number(mainBalance.value) || 0;
    const refill = Number(budget.refill) || 0;
    const percentToRefill =
        refill > 0 ? Math.min(100, (balanceValue / refill) * 100) : 0;

    const handleClick = (event) => {
        event.stopPropagation();
        onBudgetClick(budget);
    };

    return (
        <Paper
            elevation={10}
            sx={{ position: "relative", display: "inline-block" }}
            onClick={handleClick}
            className="budget"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleClick(e)}
            aria-label={`Budget: ${budget.name}`}
        >
            <Box sx={{ left: 2, position: "absolute" }}>
                <CircularProgressWithLabel value={Math.round(percentToRefill)} />
            </Box>
            <Box sx={{ width: "55%", paddingLeft: 12, paddingTop: 1, position: "absolute" }}>
                <Typography component="div" sx={{ fontWeight: 800 }}>
                    {budget.name}
                </Typography>
                <Typography component="div" sx={{ fontWeight: 1000 }} color="primary.main">
                    <strong>
                        <WalletBalance wallet={mainBalance} />
                    </strong>
                    {otherBalances.length > 0 &&
                        otherBalances.map((balance) => (
                            <Typography
                                key={balance.currency}
                                component="span"
                                sx={{ fontWeight: 450 }}
                                color="primary.main"
                            >
                                , <WalletBalance wallet={balance} />
                            </Typography>
                        ))}
                </Typography>
            </Box>
        </Paper>
    );
};

Budget.propTypes = {
    budget: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        currency: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        refill: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        balances: PropTypes.arrayOf(
            PropTypes.shape({
                currency: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            })
        ),
    }).isRequired,
    onBudgetClick: PropTypes.func.isRequired,
};

export default Budget;